// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vh 20px;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 700px;
  max-height: 800px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

/* Responsive height adjustments */
@media (max-height: 800px) {
  .modal-overlay {
    padding: 5vh 20px;
  }

  .modal-content {
    height: 90vh;
    min-height: 400px;
  }
}

@media (min-height: 900px) {
  .modal-content {
    max-height: 90vh;
  }
}

/* Progress card layout - only on larger screens */
.modal-content.with-progress-card {
  max-width: 1200px;
  width: 95%;
  height: 85vh;
  max-height: 900px;
}

.modal-content-with-sidebar {
  display: flex;
  flex: 1 1;
  min-height: 0;
}

.modal-main-content {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.modal-progress-sidebar {
  flex: 1 1;
  border-left: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  min-width: 300px;
  max-width: 400px;
}

.progress-card {
  padding: 20px;
  height: 100%;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  box-sizing: border-box;
}

.progress-card .recap-section {
  margin-bottom: 16px;
  padding: 12px;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-card .recap-item {
  padding: 8px 0;
}

.progress-card .recap-section.editable .edit-icon {
  opacity: 0;
  transition: opacity 0.2s;
  color: var(--primary-color);
}

.progress-card .recap-section.editable:hover .edit-icon {
  opacity: 1;
}

.progress-card .recap-section.editable:hover {
  background-color: #f0f0f0;
}

/* Hide progress card on smaller screens */
@media (max-width: 1024px) {
  .modal-content.with-progress-card {
    max-width: 700px;
    width: 90%;
  }

  .modal-content-with-sidebar {
    display: block;
  }

  .modal-progress-sidebar {
    display: none;
  }

  .modal-main-content {
    flex: none;
  }
}

/* V2 Variant Styles */
.variant-v2 .step.completed {
  background-color: rgba(var(--primary-color-rgb), 0.25);
  color: var(--primary-color);
}

.variant-v2 .step-line.completed {
  background-color: rgba(var(--primary-color-rgb), 0.25);
}

.variant-v2 .action-button.secondary {
  background-color: var(--secondary-button-bg);
  color: var(--secondary-button-text);
  border: 1px solid var(--secondary-button-bg);
}

.variant-v2 .action-button.primary {
  background-color: var(--primary-button-bg);
  color: var(--primary-button-text);
}

.variant-v2 .action-button.primary:hover:not(:disabled) {
  background-color: var(--primary-color-dark);
}

/* Typography System */
.variant-v2 h1 {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 24px 0;
  color: #333;
}

.variant-v2 h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0 0 20px 0;
  color: #333;
}

.variant-v2 h3 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0 0 16px 0;
  color: #333;
}

.variant-v2 h4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 12px 0;
  color: #333;
}

.variant-v2 .subtitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px 0;
  color: #555;
}

.variant-v2 .body-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  margin: 0 0 8px 0;
  color: #666;
}

.variant-v2 .caption {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 8px 0;
  color: #777;
}

.variant-v2 .label {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 4px 0;
  color: #333;
}

.variant-v2 .error-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 8px 0;
  color: #c53030;
}

.variant-v2 .success-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px 0;
  color: #28a745;
}

/* V1 Typography System (matching V2) */
h1 {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 24px 0;
  color: #333;
}

h2 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0 0 20px 0;
  color: #333;
}

h3 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0 0 16px 0;
  color: #333;
}

h4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 12px 0;
  color: #333;
}

.subtitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px 0;
  color: #555;
}

.body-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  margin: 0 0 8px 0;
  color: #666;
}

.caption {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 8px 0;
  color: #777;
}

.label {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  margin: 0 0 4px 0;
  color: #333;
}

.error-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 8px 0;
  color: #c53030;
}

.success-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px 0;
  color: #28a745;
}

/* Recap header with icon */
.recap-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
}

.recap-header-icon {
  color: var(--primary-color);
  font-size: 20px !important;
  display: flex;
  align-items: center;
}

.recap-header h3 {
  margin: 0 !important;
  display: flex;
  align-items: center;
  line-height: 1;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  /* CIN-6962 (CIN-5735 QA MAJOR gap): with viewport-fit=cover in public/index.html
     the sticky header lays out under the notch / dynamic island, so add the top
     and side insets on top of the existing 20px. The \`, 0px\` fallback INSIDE each
     env() is what makes this an exact no-op - calc(20px + 0px) = 20px - on every
     non-notched device and in the cross-origin embed iframe, where browsers report
     no insets. Do not rely on the \`padding: 20px\` shorthand above as a separate
     fallback declaration: cssnano in the CRA production build merges it with these
     longhands into a single shorthand. That is fine, because env() itself is
     supported by every browser in this project's browserslist. These longhands
     live in the BASE rule on purpose - see .modal-footer for why. */
  padding-top: calc(20px + env(safe-area-inset-top, 0px));
  padding-left: calc(20px + env(safe-area-inset-left, 0px));
  padding-right: calc(20px + env(safe-area-inset-right, 0px));
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  flex-shrink: 0;
}

/* CIN-6962: above 1024px the logo stays an absolutely positioned overlay and the
   room for it is reserved by the \`margin: 0 160px\` side gutters on
   .modal-title-group below - that combination is the CIN-5735 desktop/laptop
   layout and must not change. At <= 1024px the gutters shrink but this 120px cap
   did not, which is what painted the logo on top of the title/name/address; the
   responsive blocks pull the logo back into the flex row instead. */
.modal-logo {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.modal-logo img {
  max-height: 40px;
  max-width: 120px;
  object-fit: contain;
}

.modal-header h2 {
  flex: 1 1;
  text-align: center;
  margin: 0 160px 0 160px;
  /* Space for logo and close button */
  color: #333;
  font-size: 24px;
}

/* CIN-6784: the step title and the merchant name stack in the centered slot.
   The group takes over the h2's side margins (which reserve room for the
   absolutely positioned logo and the close button) and the h2's own margins are
   zeroed inside it, so the header layout is unchanged when no name is present. */
.modal-header .modal-title-group {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin: 0 160px;
}

.modal-header .modal-title-group h2 {
  margin: 0;
  max-width: 100%;
}

.modal-company-name {
  max-width: 100%;
  color: #666;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  /* Long merchant names must not push into the logo or the close button. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* CIN-6879: the store address sits directly under the merchant name and must be
   above the fold on EVERY step. Deliberately NOT nowrap/ellipsis like
   .modal-company-name above: at 375px the title group is squeezed to
   \`margin: 0 44px\` and an ellipsised address would drop the zip code, which is
   exactly the Reserve with Google requirement. It wraps instead. It must never
   be \`display: none\` at any breakpoint. */
.modal-location-address {
  max-width: 100%;
  color: #555;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
}

.close-button {
  background: none;
  border: none;
  font-size: 32px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  /* CIN-6962 (AC2): the X is a flex child of .modal-header. Pin it so it can
     never be shrunk or squeezed off the flex line by a wide logo or a long
     merchant name at any width. Inert above 1024px, where nothing applies
     shrink pressure. */
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f0f0f0;
  color: #333;
}

/* Step Indicator Styles */
.step-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  background-color: #f8f9fa;
}

.step-container {
  display: flex;
  align-items: center;
}

.step {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s;
}

.step.active {
  background-color: var(--primary-color);
  color: white;
}

.step.completed {
  background-color: rgba(var(--primary-color-rgb), 0.25);
  color: var(--primary-color);
}

.step-line {
  width: 60px;
  height: 2px;
  background-color: #e0e0e0;
  margin: 0 8px;
  transition: all 0.3s;
}

.step-line.completed {
  background-color: rgba(var(--primary-color-rgb), 0.25);
}

.modal-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  box-sizing: border-box;
}

.step-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 1024px) {
  .modal-overlay {
    padding: 0;
  }

  .modal-content {
    width: 100%;
    height: 100vh !important;
    max-width: 100%;
    max-height: 100vh !important;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  .modal-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
    flex-shrink: 0;
  }

  /* CIN-6962: take the logo OUT of the overlay and make it a real flex item, so
     the header becomes [logo | flexible title group | close X] and overlap is
     structurally impossible instead of depending on the title group's gutters
     staying wider than the logo's max-width. \`.modal-header .modal-logo\` (0,2,0)
     outranks the base \`.modal-logo\` (0,1,0) regardless of source order. */
  .modal-header .modal-logo {
    position: static;
    transform: none;
    flex: 0 0 auto;
    min-width: 0;
    margin-right: 8px;
    display: flex;
    align-items: center;
  }

  /* The base cap is 120px wide, which is wider than the gutter this breakpoint
     used to reserve. Shrink it so the logo cannot eat the title column. */
  .modal-header .modal-logo img {
    max-width: 72px;
    max-height: 32px;
  }

  .modal-header h2 {
    font-size: 20px;
    margin: 0 80px;
  }

  /* CIN-6784: mirror the h2 side margins on the title group at this breakpoint.
     CIN-6962: the gutters no longer reserve space for an overlaying logo (the
     logo is in flow above), so they collapse to a plain gap. Net effect is MORE
     room for the merchant name and the address, not less. */
  .modal-header .modal-title-group {
    margin: 0 8px;
  }

  .modal-company-name {
    font-size: 13px;
  }

  /* CIN-6879: address stays visible (never hidden) at tablet width. */
  .modal-location-address {
    font-size: 12px;
  }

  .modal-body {
    padding: 16px;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
  }

  .step-content {
    height: auto;
    flex: 1 1;
    overflow-y: auto;
  }

  .modal-footer {
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    background-color: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
}

/* Location List Styles */
.locations-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.location-item {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 2px solid #e0e0e0;
  transition: all 0.2s;
  cursor: pointer;
}

.location-item:hover {
  background-color: #e9ecef;
  border-color: #c0c0c0;
}

.location-item.selected {
  background-color: rgba(var(--primary-color-rgb), 0.1);
  border-color: var(--primary-color);
}

.location-item h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.location-item p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}

/* Services List Styles */
.services-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

/* Search styles */
.search-container {
  margin-bottom: 24px;
  padding: 0 16px;
  width: 100%;
  box-sizing: border-box;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.search-input::placeholder {
  color: #999;
}

.service-group {
  margin-bottom: 24px;
}

.service-group:last-child {
  margin-bottom: 0;
}

.service-group-header {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.service-group-header:not(.clickable) {
  justify-content: center;
}

.service-group-header.clickable {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 8px;
  border-radius: 8px;
  margin: -8px -8px 16px -8px;
}

.service-group-header.clickable:hover {
  background-color: rgba(var(--primary-color-rgb), 0.04);
}

.service-group-header.clickable:focus {
  outline: none;
}

.service-group-title-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.service-group-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--primary-color);
  margin: 0 !important;
  padding: 0;
  white-space: nowrap;
}

.service-group-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  font-size: 16px;
  font-weight: bold;
  transition: transform 0.2s ease, background-color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}

.service-group-icon.expanded {
  transform: rotate(0deg);
}

.service-group-icon.collapsed {
  transform: rotate(0deg);
}

.service-group-header.clickable:hover .service-group-icon {
  background-color: var(--primary-color-dark);
}

.service-group-divider {
  flex: 1 1;
  height: 1px;
  background-color: rgba(var(--primary-color-rgb), 0.2);
}

.service-group-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}

.service-group-items.collapsed {
  max-height: 0;
  opacity: 0;
  margin-top: -16px;
  padding-top: 0;
  gap: 0;
}

.service-group-items.expanded {
  max-height: none;
  opacity: 1;
  margin-top: 0;
  padding-top: 0;
}

.service-item {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
  max-width: 100%;
}

.service-item:hover {
  background-color: #e9ecef;
  border-color: #c0c0c0;
}

.service-item.selected {
  background-color: transparent;
  border-color: black;
  border-width: 2px;
}

.service-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.service-info {
  flex: 1 1;
}

.service-info h3 {
  margin: 0 0 4px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.service-info p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

/* Personal Info Form Styles */
.personal-info-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 400px;
  margin: 0 auto;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.form-group label {
  color: #333;
  font-weight: 600;
  font-size: 14px;
}

/* CIN-6871: required-field indicator. The mark is a sibling of <label> (so the
   label's queryable/accessible text stays unchanged), and .form-group is a
   column flexbox — hence this inline wrapper to keep the asterisk beside the
   label text instead of stacking under it. */
.form-group .field-label {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.required-mark {
  color: #dc3545;
  font-weight: 700;
  line-height: 1;
}

.field-checkbox .required-mark {
  margin-left: 4px;
}

.required-legend {
  font-size: 13px;
  color: #666;
  margin: 0 0 12px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
  background-color: white;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.form-group input:disabled,
.form-group select:disabled {
  background-color: #f0f0f0;
  cursor: not-allowed;
  color: #666;
}

.form-group input.error,
.form-group select.error {
  border-color: #dc3545;
  background-color: #fff5f5;
}

.form-group input.error:focus,
.form-group select.error:focus {
  border-color: #c53030;
  box-shadow: 0 0 0 1px rgba(220, 53, 69, 0.2);
}

.form-group .error-message {
  display: block;
  color: #dc3545;
  font-size: 13px;
  margin-top: 4px;
  line-height: 1.4;
}

.form-select {
  background-color: white;
  cursor: pointer;
}

/* Stylized checkbox for boolean data fields */
.field-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 16px;
  color: #333;
  padding: 6px 0;
}

.field-checkbox input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.field-checkbox .field-checkbox-box {
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: white;
  flex-shrink: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.field-checkbox .field-checkbox-box::after {
  content: '';
  width: 6px;
  height: 11px;
  margin-top: -2px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  transition: transform 0.15s ease;
}

.field-checkbox input:checked + .field-checkbox-box {
  background: var(--primary-color);
  border-color: var(--primary-color);
}

.field-checkbox input:checked + .field-checkbox-box::after {
  transform: rotate(45deg) scale(1);
}

.field-checkbox input:focus-visible + .field-checkbox-box {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.08);
}

/* Removed custom select styles - not needed for alpha */

/* Removed datalist styling - not needed */

/* Form sections and layout */
.form-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--primary-color);
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row .form-group {
  flex: 1 1;
  margin-bottom: 0;
}

/* Full width form for contact info step */
.personal-info-form {
  max-width: none;
  width: 100%;
}

/* Mobile responsive for form rows */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 12px;
  }

  .form-section {
    margin-bottom: 24px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
}

/* Phone validation only styles */
.phone-validation-only {
  max-width: 400px;
  margin: 40px auto;
  text-align: center;
}

.phone-validation-only .section-title {
  border-bottom: none;
  margin-bottom: 12px;
}

.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
}

.phone-validation-only .form-group {
  margin-bottom: 20px;
}

.phone-input-large {
  font-size: 20px !important;
  padding: 16px !important;
  text-align: center;
  letter-spacing: 2px;
}

.verified-badge {
  color: #28a745;
  font-size: 14px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(8px);
  display: inline-flex;
  align-items: center;
}

/* Date Selection Styles */
.date-selection {
  padding: 10px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.calendar-month {
  margin-bottom: 30px;
}

.calendar-month:last-child {
  margin-bottom: 0;
}

.calendar-month-name {
  text-align: center;
  margin: 0 0 15px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.calendar-grid {
  max-width: 350px;
  margin: 0 auto;
}

.calendar-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin-bottom: 5px;
}

.calendar-day-name {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  padding: 5px;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.calendar-day {
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.calendar-day.empty {
  background-color: transparent;
  border: none;
  cursor: default;
}

.calendar-day:not(.disabled):not(.empty):hover {
  background-color: #e9ecef;
  border-color: #c0c0c0;
}

.calendar-day.selected {
  background-color: var(--primary-color);
  border-color: #0056b3;
  color: white;
}

.calendar-day.disabled {
  background-color: #f0f0f0;
  color: #ccc;
  cursor: not-allowed;
  border-color: #e0e0e0;
}

.calendar-day.today {
  border-color: #007bff;
  font-weight: 700;
}

/* Recap Styles */
.recap {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.recap-section {
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.recap-section h3 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.recap-item {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.recap-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.recap-item strong {
  color: #333;
  font-size: 16px;
}

.recap-item p {
  margin: 4px 0;
  color: #666;
  font-size: 14px;
}

/* Modal Footer Styles */
.modal-footer {
  padding: 20px;
  /* CIN-6962 (CIN-5735 QA MAJOR gap): with viewport-fit=cover the document also
     extends under the iOS home indicator, so the SIDE insets belong here (they
     matter in landscape, where safe-area-inset-left/right are ~44px). The BOTTOM
     inset deliberately does NOT live on this rule: .modal-footer is not the
     bottom-most row of the modal column - <PoweredByCinch /> is rendered after
     it in both header copies (Scheduler.js:284 and :510) - and this footer is
     gated on \`currentStep <= totalSteps\`, so it is absent entirely on the
     success and cancelled/expired screens. The bottom inset is on
     \`.modal-content .powered-by-cinch\` below, which is always last. Putting it
     in both places would leave ~80px of dead space under the buttons.
     These longhands MUST live in this base rule, not in the
     @media (max-width: 1024px) \`.modal-footer\` block further UP the file: media
     queries add no specificity, so this later \`padding: 20px\` shorthand would
     silently overwrite anything that block declared. Same \`, 0px\` in-env()
     fallback as .modal-header, so it is a byte-for-byte no-op off iOS. */
  padding-left: calc(20px + env(safe-area-inset-left, 0px));
  padding-right: calc(20px + env(safe-area-inset-right, 0px));
  border-top: 1px solid #e0e0e0;
  flex-shrink: 0;
}

/* CIN-6962 (CIN-5735 QA MAJOR gap): the LAST child of .modal-content is always
   <PoweredByCinch /> - the CIN-6441 Google Place Actions platform-provider
   disclosure - on every screen, including the success and cancelled/expired
   screens where .modal-footer is not rendered at all. At <= 1024px
   .modal-overlay has no padding and .modal-content is a full-height flex column,
   so this row sits flush with the physical bottom of the screen; with
   viewport-fit=cover that is inside the ~34px home-indicator zone unless it pays
   the inset back itself.
   The base padding here is the 8px from .powered-by-cinch in PoweredByCinch.css,
   which is NOT in this ticket's scope. This selector is (0,2,0) against that
   rule's (0,1,0), so it wins on specificity no matter which order the bundler
   concatenates the two stylesheets in - do not "simplify" it to
   \`.powered-by-cinch\`. That is not a style preference: in the shipped
   build/static/css/main.*.css, PoweredByCinch.css's \`padding: 8px 16px\`
   shorthand lands ~9KB AFTER this rule, so a same-specificity selector here
   would be overwritten and the inset would silently do nothing in production.
   Same \`, 0px\` in-env() fallback as the two rules above:
   calc(8px + 0px) = 8px, an exact no-op off iOS. */
.modal-content .powered-by-cinch {
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-button {
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.action-button.primary {
  background-color: var(--primary-button-bg);
  color: var(--primary-button-text);
}

.action-button.primary:hover:not(:disabled) {
  background-color: var(--primary-color-dark);
}

.action-button.primary:disabled {
  background-color: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

.action-button.secondary {
  background-color: var(--secondary-button-bg);
  color: var(--secondary-button-text);
  border: 1px solid var(--secondary-button-bg);
}

.action-button.secondary:hover {
  background-color: var(--secondary-button-bg);
  opacity: 0.9;
}

/* Pagination Styles */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.pagination-button {
  padding: 8px 16px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.pagination-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.pagination-button:disabled {
  background-color: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

.page-info {
  color: #666;
  font-size: 14px;
  font-weight: 500;
}

/* Success Screen Styles */
.success-screen {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  height: auto !important;
  min-height: 0 !important;
}

.success-icon {
  width: 80px;
  height: 80px;
  background-color: #28a745;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 24px;
  animation: checkmark 0.5s ease;
}

@keyframes checkmark {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-screen h2 {
  color: #333;
  font-size: 28px;
  margin: 0 0 16px 0;
}

.success-message {
  color: #666;
  font-size: 18px;
  margin: 0 0 8px 0;
  line-height: 1.5;
}

.success-submessage {
  color: #888;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

/* Mobile Responsive Styles */
@media (max-width: 600px) {
  .modal-overlay {
    padding: 0;
  }

  .modal-content {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  .step-indicator {
    display: none;
  }

  .modal-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
  }

  /* CIN-6962: the \`position: static\` override from the <= 1024px block already
     applies here (1024px also matches phone widths); only the cap tightens again
     so the logo keeps a small share of a 320-412px header. */
  .modal-header .modal-logo img {
    max-width: 56px;
    max-height: 28px;
  }

  .modal-header h2 {
    font-size: 17px;
    margin: 0 44px;
  }

  /* CIN-6784: mirror the h2 side margins on the title group at this breakpoint.
     CIN-6962: collapsed from 44px - the logo is an in-flow sibling now, so the
     gutter no longer has to fake room for it. At 375px the title column grows
     from ~215px to ~223px, so the CIN-6879 zip-code requirement is preserved. */
  .modal-header .modal-title-group {
    margin: 0 6px;
  }

  .modal-company-name {
    font-size: 12px;
  }

  /* CIN-6879: address stays visible (never hidden) at phone width; it wraps to
     a second line rather than ellipsising the zip away. */
  .modal-location-address {
    font-size: 12px;
  }

  .modal-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 15px;
  }

  .modal-footer {
    position: sticky;
    bottom: 0;
    background-color: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  /* Adjust form elements for mobile */
  .personal-info-form {
    max-width: 100%;
  }

  /* Adjust calendar for mobile */
  .calendar-grid {
    max-width: 100%;
  }

  .calendar-day {
    font-size: 12px;
  }

  /* Adjust service and location items for mobile */
  .location-item h3,
  .service-info h3 {
    font-size: 16px;
  }

  .location-item p,
  .service-info p {
    font-size: 12px;
  }

  /* Make buttons full width on mobile */
  .modal-actions {
    gap: 10px;
  }

  .action-button {
    flex: 1 1;
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Scheduler.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb;;;;;;;;;oEASkE;EAClE,uDAAuD;EACvD,yDAAyD;EACzD,2DAA2D;EAC3D,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;oEAKoE;AACpE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;;;iFAGiF;AACjF;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;0CAK0C;AAC1C;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;uBAGqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;;EAEA;;;;0EAIwE;EACxE;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;0EACwE;EACxE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;;4DAG0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA,oEAAoE;EACpE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;EAC5C;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2DAA2D;EAC3D,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;6CAG6C;AAC7C;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA,wDAAwD;;AAExD,0CAA0C;;AAE1C,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb;;;;;;;;;;;;;;yEAcuE;EACvE,yDAAyD;EACzD,2DAA2D;EAC3D,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;mDAiBmD;AACnD;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,uBAAuB;EACzB;;EAEA;;6DAE2D;EAC3D;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;;gFAG8E;EAC9E;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;0DACwD;EACxD;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,0CAA0C;EAC5C;;EAEA,oCAAoC;EACpC;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,iDAAiD;EACjD;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,SAAS;EACX;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10vh 20px;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 700px;\n  max-height: 800px;\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Responsive height adjustments */\n@media (max-height: 800px) {\n  .modal-overlay {\n    padding: 5vh 20px;\n  }\n\n  .modal-content {\n    height: 90vh;\n    min-height: 400px;\n  }\n}\n\n@media (min-height: 900px) {\n  .modal-content {\n    max-height: 90vh;\n  }\n}\n\n/* Progress card layout - only on larger screens */\n.modal-content.with-progress-card {\n  max-width: 1200px;\n  width: 95%;\n  height: 85vh;\n  max-height: 900px;\n}\n\n.modal-content-with-sidebar {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n.modal-main-content {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.modal-progress-sidebar {\n  flex: 1;\n  border-left: 1px solid #e0e0e0;\n  background-color: #f8f9fa;\n  min-width: 300px;\n  max-width: 400px;\n}\n\n.progress-card {\n  padding: 20px;\n  height: 100%;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.progress-card .recap-section {\n  margin-bottom: 16px;\n  padding: 12px;\n  background-color: white;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.progress-card .recap-item {\n  padding: 8px 0;\n}\n\n.progress-card .recap-section.editable .edit-icon {\n  opacity: 0;\n  transition: opacity 0.2s;\n  color: var(--primary-color);\n}\n\n.progress-card .recap-section.editable:hover .edit-icon {\n  opacity: 1;\n}\n\n.progress-card .recap-section.editable:hover {\n  background-color: #f0f0f0;\n}\n\n/* Hide progress card on smaller screens */\n@media (max-width: 1024px) {\n  .modal-content.with-progress-card {\n    max-width: 700px;\n    width: 90%;\n  }\n\n  .modal-content-with-sidebar {\n    display: block;\n  }\n\n  .modal-progress-sidebar {\n    display: none;\n  }\n\n  .modal-main-content {\n    flex: none;\n  }\n}\n\n/* V2 Variant Styles */\n.variant-v2 .step.completed {\n  background-color: rgba(var(--primary-color-rgb), 0.25);\n  color: var(--primary-color);\n}\n\n.variant-v2 .step-line.completed {\n  background-color: rgba(var(--primary-color-rgb), 0.25);\n}\n\n.variant-v2 .action-button.secondary {\n  background-color: var(--secondary-button-bg);\n  color: var(--secondary-button-text);\n  border: 1px solid var(--secondary-button-bg);\n}\n\n.variant-v2 .action-button.primary {\n  background-color: var(--primary-button-bg);\n  color: var(--primary-button-text);\n}\n\n.variant-v2 .action-button.primary:hover:not(:disabled) {\n  background-color: var(--primary-color-dark);\n}\n\n/* Typography System */\n.variant-v2 h1 {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 24px 0;\n  color: #333;\n}\n\n.variant-v2 h2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 0 0 20px 0;\n  color: #333;\n}\n\n.variant-v2 h3 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.4;\n  margin: 0 0 16px 0;\n  color: #333;\n}\n\n.variant-v2 h4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 12px 0;\n  color: #333;\n}\n\n.variant-v2 .subtitle {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 12px 0;\n  color: #555;\n}\n\n.variant-v2 .body-text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6;\n  margin: 0 0 8px 0;\n  color: #666;\n}\n\n.variant-v2 .caption {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n  color: #777;\n}\n\n.variant-v2 .label {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 4px 0;\n  color: #333;\n}\n\n.variant-v2 .error-text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n  color: #c53030;\n}\n\n.variant-v2 .success-text {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 12px 0;\n  color: #28a745;\n}\n\n/* V1 Typography System (matching V2) */\nh1 {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 24px 0;\n  color: #333;\n}\n\nh2 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 0 0 20px 0;\n  color: #333;\n}\n\nh3 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.4;\n  margin: 0 0 16px 0;\n  color: #333;\n}\n\nh4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 12px 0;\n  color: #333;\n}\n\n.subtitle {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 12px 0;\n  color: #555;\n}\n\n.body-text {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6;\n  margin: 0 0 8px 0;\n  color: #666;\n}\n\n.caption {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n  color: #777;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n  margin: 0 0 4px 0;\n  color: #333;\n}\n\n.error-text {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  margin: 0 0 8px 0;\n  color: #c53030;\n}\n\n.success-text {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0 0 12px 0;\n  color: #28a745;\n}\n\n/* Recap header with icon */\n.recap-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.recap-header-icon {\n  color: var(--primary-color);\n  font-size: 20px !important;\n  display: flex;\n  align-items: center;\n}\n\n.recap-header h3 {\n  margin: 0 !important;\n  display: flex;\n  align-items: center;\n  line-height: 1;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  /* CIN-6962 (CIN-5735 QA MAJOR gap): with viewport-fit=cover in public/index.html\n     the sticky header lays out under the notch / dynamic island, so add the top\n     and side insets on top of the existing 20px. The `, 0px` fallback INSIDE each\n     env() is what makes this an exact no-op - calc(20px + 0px) = 20px - on every\n     non-notched device and in the cross-origin embed iframe, where browsers report\n     no insets. Do not rely on the `padding: 20px` shorthand above as a separate\n     fallback declaration: cssnano in the CRA production build merges it with these\n     longhands into a single shorthand. That is fine, because env() itself is\n     supported by every browser in this project's browserslist. These longhands\n     live in the BASE rule on purpose - see .modal-footer for why. */\n  padding-top: calc(20px + env(safe-area-inset-top, 0px));\n  padding-left: calc(20px + env(safe-area-inset-left, 0px));\n  padding-right: calc(20px + env(safe-area-inset-right, 0px));\n  border-bottom: 1px solid #e0e0e0;\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* CIN-6962: above 1024px the logo stays an absolutely positioned overlay and the\n   room for it is reserved by the `margin: 0 160px` side gutters on\n   .modal-title-group below - that combination is the CIN-5735 desktop/laptop\n   layout and must not change. At <= 1024px the gutters shrink but this 120px cap\n   did not, which is what painted the logo on top of the title/name/address; the\n   responsive blocks pull the logo back into the flex row instead. */\n.modal-logo {\n  position: absolute;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.modal-logo img {\n  max-height: 40px;\n  max-width: 120px;\n  object-fit: contain;\n}\n\n.modal-header h2 {\n  flex: 1;\n  text-align: center;\n  margin: 0 160px 0 160px;\n  /* Space for logo and close button */\n  color: #333;\n  font-size: 24px;\n}\n\n/* CIN-6784: the step title and the merchant name stack in the centered slot.\n   The group takes over the h2's side margins (which reserve room for the\n   absolutely positioned logo and the close button) and the h2's own margins are\n   zeroed inside it, so the header layout is unchanged when no name is present. */\n.modal-header .modal-title-group {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  margin: 0 160px;\n}\n\n.modal-header .modal-title-group h2 {\n  margin: 0;\n  max-width: 100%;\n}\n\n.modal-company-name {\n  max-width: 100%;\n  color: #666;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: center;\n  /* Long merchant names must not push into the logo or the close button. */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* CIN-6879: the store address sits directly under the merchant name and must be\n   above the fold on EVERY step. Deliberately NOT nowrap/ellipsis like\n   .modal-company-name above: at 375px the title group is squeezed to\n   `margin: 0 44px` and an ellipsised address would drop the zip code, which is\n   exactly the Reserve with Google requirement. It wraps instead. It must never\n   be `display: none` at any breakpoint. */\n.modal-location-address {\n  max-width: 100%;\n  color: #555;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.3;\n  text-align: center;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 32px;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  /* CIN-6962 (AC2): the X is a flex child of .modal-header. Pin it so it can\n     never be shrunk or squeezed off the flex line by a wide logo or a long\n     merchant name at any width. Inert above 1024px, where nothing applies\n     shrink pressure. */\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.close-button:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n/* Step Indicator Styles */\n.step-indicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 40px;\n  background-color: #f8f9fa;\n}\n\n.step-container {\n  display: flex;\n  align-items: center;\n}\n\n.step {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 16px;\n  transition: all 0.3s;\n}\n\n.step.active {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n.step.completed {\n  background-color: rgba(var(--primary-color-rgb), 0.25);\n  color: var(--primary-color);\n}\n\n.step-line {\n  width: 60px;\n  height: 2px;\n  background-color: #e0e0e0;\n  margin: 0 8px;\n  transition: all 0.3s;\n}\n\n.step-line.completed {\n  background-color: rgba(var(--primary-color-rgb), 0.25);\n}\n\n.modal-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.step-content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media (max-width: 1024px) {\n  .modal-overlay {\n    padding: 0;\n  }\n\n  .modal-content {\n    width: 100%;\n    height: 100vh !important;\n    max-width: 100%;\n    max-height: 100vh !important;\n    border-radius: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-header {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: white;\n    flex-shrink: 0;\n  }\n\n  /* CIN-6962: take the logo OUT of the overlay and make it a real flex item, so\n     the header becomes [logo | flexible title group | close X] and overlap is\n     structurally impossible instead of depending on the title group's gutters\n     staying wider than the logo's max-width. `.modal-header .modal-logo` (0,2,0)\n     outranks the base `.modal-logo` (0,1,0) regardless of source order. */\n  .modal-header .modal-logo {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n    min-width: 0;\n    margin-right: 8px;\n    display: flex;\n    align-items: center;\n  }\n\n  /* The base cap is 120px wide, which is wider than the gutter this breakpoint\n     used to reserve. Shrink it so the logo cannot eat the title column. */\n  .modal-header .modal-logo img {\n    max-width: 72px;\n    max-height: 32px;\n  }\n\n  .modal-header h2 {\n    font-size: 20px;\n    margin: 0 80px;\n  }\n\n  /* CIN-6784: mirror the h2 side margins on the title group at this breakpoint.\n     CIN-6962: the gutters no longer reserve space for an overlaying logo (the\n     logo is in flow above), so they collapse to a plain gap. Net effect is MORE\n     room for the merchant name and the address, not less. */\n  .modal-header .modal-title-group {\n    margin: 0 8px;\n  }\n\n  .modal-company-name {\n    font-size: 13px;\n  }\n\n  /* CIN-6879: address stays visible (never hidden) at tablet width. */\n  .modal-location-address {\n    font-size: 12px;\n  }\n\n  .modal-body {\n    padding: 16px;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n  }\n\n  .step-content {\n    height: auto;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .modal-footer {\n    flex-shrink: 0;\n    position: sticky;\n    bottom: 0;\n    background-color: white;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  }\n}\n\n/* Location List Styles */\n.locations-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.location-item {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 2px solid #e0e0e0;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.location-item:hover {\n  background-color: #e9ecef;\n  border-color: #c0c0c0;\n}\n\n.location-item.selected {\n  background-color: rgba(var(--primary-color-rgb), 0.1);\n  border-color: var(--primary-color);\n}\n\n.location-item h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.location-item p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Services List Styles */\n.services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Search styles */\n.search-container {\n  margin-bottom: 24px;\n  padding: 0 16px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.search-input::placeholder {\n  color: #999;\n}\n\n.service-group {\n  margin-bottom: 24px;\n}\n\n.service-group:last-child {\n  margin-bottom: 0;\n}\n\n.service-group-header {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.service-group-header:not(.clickable) {\n  justify-content: center;\n}\n\n.service-group-header.clickable {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  padding: 8px;\n  border-radius: 8px;\n  margin: -8px -8px 16px -8px;\n}\n\n.service-group-header.clickable:hover {\n  background-color: rgba(var(--primary-color-rgb), 0.04);\n}\n\n.service-group-header.clickable:focus {\n  outline: none;\n}\n\n.service-group-title-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.service-group-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--primary-color);\n  margin: 0 !important;\n  padding: 0;\n  white-space: nowrap;\n}\n\n.service-group-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--primary-color);\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.service-group-icon.expanded {\n  transform: rotate(0deg);\n}\n\n.service-group-icon.collapsed {\n  transform: rotate(0deg);\n}\n\n.service-group-header.clickable:hover .service-group-icon {\n  background-color: var(--primary-color-dark);\n}\n\n.service-group-divider {\n  flex: 1;\n  height: 1px;\n  background-color: rgba(var(--primary-color-rgb), 0.2);\n}\n\n.service-group-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.service-group-items.collapsed {\n  max-height: 0;\n  opacity: 0;\n  margin-top: -16px;\n  padding-top: 0;\n  gap: 0;\n}\n\n.service-group-items.expanded {\n  max-height: none;\n  opacity: 1;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.service-item {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 2px solid #e0e0e0;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.service-item:hover {\n  background-color: #e9ecef;\n  border-color: #c0c0c0;\n}\n\n.service-item.selected {\n  background-color: transparent;\n  border-color: black;\n  border-width: 2px;\n}\n\n.service-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.service-info {\n  flex: 1;\n}\n\n.service-info h3 {\n  margin: 0 0 4px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.service-info p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Personal Info Form Styles */\n.personal-info-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n\n.form-group label {\n  color: #333;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* CIN-6871: required-field indicator. The mark is a sibling of <label> (so the\n   label's queryable/accessible text stays unchanged), and .form-group is a\n   column flexbox — hence this inline wrapper to keep the asterisk beside the\n   label text instead of stacking under it. */\n.form-group .field-label {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.required-mark {\n  color: #dc3545;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.field-checkbox .required-mark {\n  margin-left: 4px;\n}\n\n.required-legend {\n  font-size: 13px;\n  color: #666;\n  margin: 0 0 12px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n  background-color: white;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.form-group input:disabled,\n.form-group select:disabled {\n  background-color: #f0f0f0;\n  cursor: not-allowed;\n  color: #666;\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: #dc3545;\n  background-color: #fff5f5;\n}\n\n.form-group input.error:focus,\n.form-group select.error:focus {\n  border-color: #c53030;\n  box-shadow: 0 0 0 1px rgba(220, 53, 69, 0.2);\n}\n\n.form-group .error-message {\n  display: block;\n  color: #dc3545;\n  font-size: 13px;\n  margin-top: 4px;\n  line-height: 1.4;\n}\n\n.form-select {\n  background-color: white;\n  cursor: pointer;\n}\n\n/* Stylized checkbox for boolean data fields */\n.field-checkbox {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n  font-size: 16px;\n  color: #333;\n  padding: 6px 0;\n}\n\n.field-checkbox input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.field-checkbox .field-checkbox-box {\n  width: 22px;\n  height: 22px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  flex-shrink: 0;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.field-checkbox .field-checkbox-box::after {\n  content: '';\n  width: 6px;\n  height: 11px;\n  margin-top: -2px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg) scale(0);\n  transition: transform 0.15s ease;\n}\n\n.field-checkbox input:checked + .field-checkbox-box {\n  background: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n.field-checkbox input:checked + .field-checkbox-box::after {\n  transform: rotate(45deg) scale(1);\n}\n\n.field-checkbox input:focus-visible + .field-checkbox-box {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.08);\n}\n\n/* Removed custom select styles - not needed for alpha */\n\n/* Removed datalist styling - not needed */\n\n/* Form sections and layout */\n.form-section {\n  margin-bottom: 32px;\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 20px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid var(--primary-color);\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n/* Full width form for contact info step */\n.personal-info-form {\n  max-width: none;\n  width: 100%;\n}\n\n/* Mobile responsive for form rows */\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .form-section {\n    margin-bottom: 24px;\n  }\n\n  .section-title {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n}\n\n/* Phone validation only styles */\n.phone-validation-only {\n  max-width: 400px;\n  margin: 40px auto;\n  text-align: center;\n}\n\n.phone-validation-only .section-title {\n  border-bottom: none;\n  margin-bottom: 12px;\n}\n\n.section-description {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 30px;\n}\n\n.phone-validation-only .form-group {\n  margin-bottom: 20px;\n}\n\n.phone-input-large {\n  font-size: 20px !important;\n  padding: 16px !important;\n  text-align: center;\n  letter-spacing: 2px;\n}\n\n.verified-badge {\n  color: #28a745;\n  font-size: 14px;\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(8px);\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Date Selection Styles */\n.date-selection {\n  padding: 10px;\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.calendar-month {\n  margin-bottom: 30px;\n}\n\n.calendar-month:last-child {\n  margin-bottom: 0;\n}\n\n.calendar-month-name {\n  text-align: center;\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.calendar-grid {\n  max-width: 350px;\n  margin: 0 auto;\n}\n\n.calendar-header {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n  margin-bottom: 5px;\n}\n\n.calendar-day-name {\n  text-align: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  padding: 5px;\n}\n\n.calendar-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n}\n\n.calendar-day {\n  aspect-ratio: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.calendar-day.empty {\n  background-color: transparent;\n  border: none;\n  cursor: default;\n}\n\n.calendar-day:not(.disabled):not(.empty):hover {\n  background-color: #e9ecef;\n  border-color: #c0c0c0;\n}\n\n.calendar-day.selected {\n  background-color: var(--primary-color);\n  border-color: #0056b3;\n  color: white;\n}\n\n.calendar-day.disabled {\n  background-color: #f0f0f0;\n  color: #ccc;\n  cursor: not-allowed;\n  border-color: #e0e0e0;\n}\n\n.calendar-day.today {\n  border-color: #007bff;\n  font-weight: 700;\n}\n\n/* Recap Styles */\n.recap {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.recap-section {\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.recap-section h3 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.recap-item {\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.recap-item:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.recap-item strong {\n  color: #333;\n  font-size: 16px;\n}\n\n.recap-item p {\n  margin: 4px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n/* Modal Footer Styles */\n.modal-footer {\n  padding: 20px;\n  /* CIN-6962 (CIN-5735 QA MAJOR gap): with viewport-fit=cover the document also\n     extends under the iOS home indicator, so the SIDE insets belong here (they\n     matter in landscape, where safe-area-inset-left/right are ~44px). The BOTTOM\n     inset deliberately does NOT live on this rule: .modal-footer is not the\n     bottom-most row of the modal column - <PoweredByCinch /> is rendered after\n     it in both header copies (Scheduler.js:284 and :510) - and this footer is\n     gated on `currentStep <= totalSteps`, so it is absent entirely on the\n     success and cancelled/expired screens. The bottom inset is on\n     `.modal-content .powered-by-cinch` below, which is always last. Putting it\n     in both places would leave ~80px of dead space under the buttons.\n     These longhands MUST live in this base rule, not in the\n     @media (max-width: 1024px) `.modal-footer` block further UP the file: media\n     queries add no specificity, so this later `padding: 20px` shorthand would\n     silently overwrite anything that block declared. Same `, 0px` in-env()\n     fallback as .modal-header, so it is a byte-for-byte no-op off iOS. */\n  padding-left: calc(20px + env(safe-area-inset-left, 0px));\n  padding-right: calc(20px + env(safe-area-inset-right, 0px));\n  border-top: 1px solid #e0e0e0;\n  flex-shrink: 0;\n}\n\n/* CIN-6962 (CIN-5735 QA MAJOR gap): the LAST child of .modal-content is always\n   <PoweredByCinch /> - the CIN-6441 Google Place Actions platform-provider\n   disclosure - on every screen, including the success and cancelled/expired\n   screens where .modal-footer is not rendered at all. At <= 1024px\n   .modal-overlay has no padding and .modal-content is a full-height flex column,\n   so this row sits flush with the physical bottom of the screen; with\n   viewport-fit=cover that is inside the ~34px home-indicator zone unless it pays\n   the inset back itself.\n   The base padding here is the 8px from .powered-by-cinch in PoweredByCinch.css,\n   which is NOT in this ticket's scope. This selector is (0,2,0) against that\n   rule's (0,1,0), so it wins on specificity no matter which order the bundler\n   concatenates the two stylesheets in - do not \"simplify\" it to\n   `.powered-by-cinch`. That is not a style preference: in the shipped\n   build/static/css/main.*.css, PoweredByCinch.css's `padding: 8px 16px`\n   shorthand lands ~9KB AFTER this rule, so a same-specificity selector here\n   would be overwritten and the inset would silently do nothing in production.\n   Same `, 0px` in-env() fallback as the two rules above:\n   calc(8px + 0px) = 8px, an exact no-op off iOS. */\n.modal-content .powered-by-cinch {\n  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.action-button {\n  padding: 10px 24px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-button.primary {\n  background-color: var(--primary-button-bg);\n  color: var(--primary-button-text);\n}\n\n.action-button.primary:hover:not(:disabled) {\n  background-color: var(--primary-color-dark);\n}\n\n.action-button.primary:disabled {\n  background-color: #e0e0e0;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.action-button.secondary {\n  background-color: var(--secondary-button-bg);\n  color: var(--secondary-button-text);\n  border: 1px solid var(--secondary-button-bg);\n}\n\n.action-button.secondary:hover {\n  background-color: var(--secondary-button-bg);\n  opacity: 0.9;\n}\n\n/* Pagination Styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.pagination-button {\n  padding: 8px 16px;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.pagination-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.pagination-button:disabled {\n  background-color: #e0e0e0;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.page-info {\n  color: #666;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Success Screen Styles */\n.success-screen {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 20px;\n  height: auto !important;\n  min-height: 0 !important;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  background-color: #28a745;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  font-weight: bold;\n  margin-bottom: 24px;\n  animation: checkmark 0.5s ease;\n}\n\n@keyframes checkmark {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.success-screen h2 {\n  color: #333;\n  font-size: 28px;\n  margin: 0 0 16px 0;\n}\n\n.success-message {\n  color: #666;\n  font-size: 18px;\n  margin: 0 0 8px 0;\n  line-height: 1.5;\n}\n\n.success-submessage {\n  color: #888;\n  font-size: 16px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Mobile Responsive Styles */\n@media (max-width: 600px) {\n  .modal-overlay {\n    padding: 0;\n  }\n\n  .modal-content {\n    width: 100%;\n    height: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .step-indicator {\n    display: none;\n  }\n\n  .modal-header {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: white;\n  }\n\n  /* CIN-6962: the `position: static` override from the <= 1024px block already\n     applies here (1024px also matches phone widths); only the cap tightens again\n     so the logo keeps a small share of a 320-412px header. */\n  .modal-header .modal-logo img {\n    max-width: 56px;\n    max-height: 28px;\n  }\n\n  .modal-header h2 {\n    font-size: 17px;\n    margin: 0 44px;\n  }\n\n  /* CIN-6784: mirror the h2 side margins on the title group at this breakpoint.\n     CIN-6962: collapsed from 44px - the logo is an in-flow sibling now, so the\n     gutter no longer has to fake room for it. At 375px the title column grows\n     from ~215px to ~223px, so the CIN-6879 zip-code requirement is preserved. */\n  .modal-header .modal-title-group {\n    margin: 0 6px;\n  }\n\n  .modal-company-name {\n    font-size: 12px;\n  }\n\n  /* CIN-6879: address stays visible (never hidden) at phone width; it wraps to\n     a second line rather than ellipsising the zip away. */\n  .modal-location-address {\n    font-size: 12px;\n  }\n\n  .modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 15px;\n  }\n\n  .modal-footer {\n    position: sticky;\n    bottom: 0;\n    background-color: white;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  }\n\n  /* Adjust form elements for mobile */\n  .personal-info-form {\n    max-width: 100%;\n  }\n\n  /* Adjust calendar for mobile */\n  .calendar-grid {\n    max-width: 100%;\n  }\n\n  .calendar-day {\n    font-size: 12px;\n  }\n\n  /* Adjust service and location items for mobile */\n  .location-item h3,\n  .service-info h3 {\n    font-size: 16px;\n  }\n\n  .location-item p,\n  .service-info p {\n    font-size: 12px;\n  }\n\n  /* Make buttons full width on mobile */\n  .modal-actions {\n    gap: 10px;\n  }\n\n  .action-button {\n    flex: 1;\n    padding: 12px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
